import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { AddProductMutation, UpdateProductMutation, GetAllProductQuery } from 'shared/services/product_service/ProductService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import CustomSelect from 'shared/components/common/custom_selection/CustomSelection';
import { useFormik } from 'formik';
import { ModelVS } from 'shared/utils/validation/AuthValidation';
import { GetAllCompetibleBrandQuery } from 'shared/services/competible_brand_service/CompetibleBrandService';
import { toastMessage } from 'shared/components/toast/Toast';

export default function AddProduct({ show, handleClose, isEdit = false, editData = null, datatable, selectedCompatibleBrand, onSuccessAdd }) {
    const { mutate: addProductMutate, isLoading: ProductLoading, isSuccess: ProductIsSuccess } = AddProductMutation();
    const { mutate: updateProductMutate, isLoading: UpdateProductLoading, isSuccess: UpdateProductIsSuccess } = UpdateProductMutation();
    const { data: listBrand } = GetAllCompetibleBrandQuery();
    const { data: models } = GetAllProductQuery();

    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    useEffect(() => {
        listBrand?.map((ii) => {
            ii['label'] = ii?.name;
            return ii;
        });
    }, [listBrand]);

    useEffect(() => {
        if ((ProductIsSuccess || UpdateProductIsSuccess) && show) {
            if (onSuccessAdd) onSuccessAdd(values.model);
            setTimeout(() => {
                onClose();
            }, 100);
        }
    }, [ProductIsSuccess, UpdateProductIsSuccess]);

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    const initialValues = {
        model: isEdit && editData?.name ? editData.name : '',
        brand: isEdit && editData?.compatiableBrand ? { ...editData.compatiableBrand, label: editData.compatiableBrand.name } : (selectedCompatibleBrand || '')
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: ModelVS,
        onSubmit: (values) => {
            const isDuplicate = models?.some(
                (item) =>
                    item._id !== editData?._id &&
                    item.name.trim().toLowerCase() === values.model.trim().toLowerCase() &&
                    item.compatiableBrand?._id === values.brand?._id
            );

            if (isDuplicate) {
                toastMessage('error', `Model "${values.model}" already exists for this brand!`);
                return;
            }

            if (isEdit && editData?._id) {
                updateProductMutate({
                    id: editData._id,
                    payload: {
                        name: values.model,
                        compatiableBrand: values.brand?._id || values.brand,
                    }
                });
            } else {
                addProductMutate({
                    name: values.model,
                    compatiableBrand: values.brand?._id || values.brand,
                });
            }
        }
    });

    const { handleChange, setFieldValue, handleSubmit, values, touched, errors } = formik;

    useEffect(() => {
        if (show && !isEdit && selectedCompatibleBrand) {
            setFieldValue('brand', selectedCompatibleBrand);
        }
    }, [show, isEdit, selectedCompatibleBrand, setFieldValue]);

    return (
        <Modal show={show} onHide={onClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={isEdit ? 'Edit Model' : 'Add Model'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomSelect
                        label={'Competible Brands'}
                        placeholder={'Select Brand'}
                        options={listBrand}
                        value={values.brand}
                        onChangeHandle={(item) => {
                            setFieldValue('brand', item);
                        }}
                        MainContainerStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                    />
                    <CustomInput
                        label={isEdit ? 'Edit Model Name' : 'Add Model'}
                        placeholder={'e.g. Model'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.model}
                        onChange={handleChange('model')}
                        error={errors.model && touched.model ? errors.model : ''}
                    />

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={onClose} />
                        <CustomButton text={isEdit ? 'Update' : 'Add'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
                {(ProductLoading || UpdateProductLoading) && <OverlayLoading />}
            </Modal.Body>
        </Modal>
    );
}
